import { useState, useEffect } from "react";
import { AnimatePresence, motion } from "framer-motion";
import { SITE } from "@/config";
import { BuyButton } from "@/components/BuyButton";

export const StickyMobileCTA = () => {
  const [show, setShow] = useState(false);

  useEffect(() => {
    const onScroll = () => setShow(window.scrollY > window.innerHeight * 0.85);
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <AnimatePresence>
      {show && (
        <motion.div
          initial={{ y: 90, opacity: 0 }}
          animate={{ y: 0, opacity: 1 }}
          exit={{ y: 90, opacity: 0 }}
          transition={{ duration: 0.35, ease: [0.22, 1, 0.36, 1] }}
          className="fixed inset-x-0 bottom-0 z-50 md:hidden"
          data-testid="sticky-mobile-cta"
        >
          <div className="mx-3 mb-3 flex items-center justify-between gap-4 rounded-2xl border border-black/5 bg-white/90 px-4 py-3 shadow-[0_-6px_30px_rgba(0,0,0,0.12)] backdrop-blur-xl">
            <div className="leading-tight">
              <p className="text-[13px] font-medium text-ink">Google Review Stand</p>
              <p className="text-lg font-semibold tracking-tight text-ink">{SITE.price}</p>
            </div>
            <BuyButton testId="buy-now-sticky" className="px-6 py-3 text-sm">
              Buy now
            </BuyButton>
          </div>
        </motion.div>
      )}
    </AnimatePresence>
  );
};
